export enum PermissionFields {
  Scope = "scope",
  ScopeValues = "scopeValues",
  SeasonStatuses = "seasonStatuses",
  FixtureStatuses = "fixtureStatuses",
}
